var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3571_6621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1428 0H2.85713C1.27995 0.001875 0.001875 1.27995 0 2.85713V13.1428C0.001875 14.72 1.27995 15.9981 2.85713 16H13.1428C14.72 15.9981 15.9981 14.72 16 13.1428V2.85713C15.9981 1.27995 14.72 0.001875 13.1428 0ZM10.8571 8.57142H8.57142V10.8571C8.57142 11.1727 8.31559 11.4286 7.99998 11.4286C7.68438 11.4286 7.42854 11.1727 7.42854 10.8571V8.57142H5.14285C4.82725 8.57142 4.57141 8.31559 4.57141 7.99998C4.57141 7.68438 4.82725 7.42854 5.14285 7.42854H7.42858V5.14285C7.42858 4.82725 7.68441 4.57141 8.00002 4.57141C8.31562 4.57141 8.57142 4.82725 8.57142 5.14285V7.42858H10.8571C11.1727 7.42858 11.4286 7.68441 11.4286 8.00002C11.4286 8.31562 11.1727 8.57142 10.8571 8.57142Z",
    fill: "#FDFEFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3571_6621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.56c2b9a0c8bdc6ed4e32470840798aa3.svg";
export { ForwardRef as ReactComponent };